export default {"src":"/_next/static/media/fiji.909cf9cf.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};